import { colors } from './colors'

/**
 * Border radius design tokens.
 *
 * For use with the following CSS properties:
 *
 *     border-radius
 *
 * @see https://system-ui.com/theme
 */
export const radii = {
  base: '4px',
  small: '3px',
  medium: '5px',
  large: '6px',
  xlarge: '7px',
  xxlarge: '8px',
  xxxlarge: '16px',
  rounded: '999px',
}

/**
 * Border width design tokens.
 *
 * For use with the following CSS properties:
 *
 *     border-width
 *
 * @see https://system-ui.com/theme
 */
export const borderWidth = [0, 1, 2, 3, 4]

/**
 * Outline design tokens
 *
 * For use with focus state for accessibility purposes
 */
export const outline = {
  focusRing: `2px solid ${colors.focus.generic}`,
}
